import Image from "next/image";

import OurValuesCard from "../card/OurValuesCard";

import { reduceSize } from "utils/image";
import SectionTitle from "components/typography/SectionTitle/SectionTitle";

import styles from "./OurValues.module.scss";

const OurValues = ({ about }) => {
  return (
    <div className={`${styles.valuesArea}`} id="our-values-about">
      <div className="variable-container">
        <h2 className={`${styles.title}`}>
          <SectionTitle title="Our Values" />
        </h2>

        <div className={`${styles.columns}`}>
          <div className={`${styles.column1}`}>
            <OurValuesCard ourData={about?.ourValuesLeft} />
          </div>

          <div className={`${styles.imageWrapper}`}>
            <Image
              src={reduceSize(about?.ourValuesRight?.data?.attributes.url)}
              alt="Our values logo"
              width="520"
              height="520"
              // placeholder="blur"
              // blurDataURL={reduceSize(
              //   about?.ourValues?.ourValuesRight?.data?.attributes.url
              // )}
              loading="eager"
              priority={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurValues;
